export default "__VITE_ASSET__85820b4f__"